import {
  parseDebugDefaults,
  serializeDebugDefaults,
  type DebugDefaultsDocument,
} from '../../sim/debugDefaults/index.ts';

export const DEBUG_DEFAULTS_SAVE_PATH = '/__battleboats/save-debug-defaults';

export type SaveDebugDefaultsResult = 'saved' | 'dev-only' | 'error';

/** Vite DEV middleware can write `defaults.json`. Preview and production cannot. */
export function canWritePlayDebugDefaults(): boolean {
  return import.meta.env.DEV;
}

/** Reads the repo file through the DEV hook. Null in preview or if the hook is missing. */
export async function fetchPlayDebugDefaultsFromRepo(): Promise<DebugDefaultsDocument | null> {
  if (!canWritePlayDebugDefaults()) {
    return null;
  }

  try {
    const response = await fetch(DEBUG_DEFAULTS_SAVE_PATH, { cache: 'no-store' });

    if (!response.ok) {
      return null;
    }

    return parseDebugDefaults(await response.text());
  } catch {
    return null;
  }
}

export async function savePlayDebugDefaults(
  document: DebugDefaultsDocument,
): Promise<SaveDebugDefaultsResult> {
  if (!canWritePlayDebugDefaults()) {
    return 'dev-only';
  }

  try {
    const response = await fetch(DEBUG_DEFAULTS_SAVE_PATH, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ contents: serializeDebugDefaults(document) }),
    });
    return response.ok ? 'saved' : 'error';
  } catch {
    return 'error';
  }
}
